export const TIME_LOOKBACK_RANGES_TO_DAYS_AGO: { [key: string]: number } = {
  "1 day": 1,
  "7 days": 7,
  "1 month": 30,
  "1 year": 365,
  "All time": Infinity,
};

export const TIME_LOOKBACK_RANGES = Object.keys(
  TIME_LOOKBACK_RANGES_TO_DAYS_AGO
);

export type TimeLookbackRange = typeof TIME_LOOKBACK_RANGES[number];
